<template>
  <div id="root">
    <header>
      <img src="../../public/img/logo.png" alt="KLUKE  克鲁克机电" class="home-logo">
      <div  class="home-logo-2">
        <img src="../../public/img/logo_2.png" alt="经销商专区">
        <i class="el-icon-arrow-right"></i>
        <i class="el-icon-arrow-right"></i>
        <i class="el-icon-arrow-right"></i>
      </div>
    </header>
    <div class="home-div">
      <login-panel v-if="isLogin"   @changePage="isLogin=!isLogin" />
      <regist v-if="!isLogin" @changePage="isLogin=!isLogin" />
    </div>
    <div class="footer_page">
                <span>©  昆山克鲁克机电设备有限公司 版权所有.&nbsp;&nbsp;&nbsp;
                  <a href="https://beian.miit.gov.cn/#/Integrated/index">皖ICP备20002011号</a></span>
    </div>
  </div>
</template>

<script>
import login from "@/components/login";
import regist from "@/components/regist";
import LoginPanel from "@/components/loginPanel";
export default {
  name: "home",
  components:{
    LoginPanel,
    login,
    regist
  },
  data(){
    return{
      isLogin:true,
    }
  },
  methods:{
  },
  beforeCreate() {
    if (localStorage.getItem('token')){
      this.$store.commit('toPage','/navigation');
    }
  },

}
</script>

<style scoped>
  body{
    overflow: hidden;
    height: 100%;
    width: 100%;
    font-size: 14px;
  }
  header{
    display: flex;
    z-index: 400;
    align-items: center;
    border-bottom: 1px #dcdfe6 solid ;
    background:linear-gradient(90deg,rgba(119, 143, 158,.17),rgba(119, 143, 158,.25),rgba(119, 143, 158,.45),rgba(69, 83, 92,.7));
  }
  header img{
    z-index: 99;
    height: 7rem;
  }
  .home-logo{
    display: block;
    height: 7rem;
    margin-left: 6rem;
    padding: 1rem 0.2rem 0.8rem 0;
  }
  .home-logo-2{
    display: block;
    height: 7rem;
    position: absolute;
    right: 1.3rem;
    padding: .5rem 0.2rem 0.8rem 0;
  }
  .home-div{
    background: linear-gradient(135deg,rgba(11, 102, 189,.5),rgba(42, 82, 152));
    /*background: linear-gradient(135deg,rgba(0, 74, 146,.5),rgba(42, 82, 152,.9));*/
    width: 100%;
    line-height: 100%;
    justify-content: center;
    align-items: center;
    height: calc(100% - 7rem);
    position: fixed;
    display: flex;
    flex-direction: row;
  }
  .viewLeft img{
    width: 100%;
    height: 100%;
    object-fit: fill;
  }
  .el-icon-arrow-right{
    font-weight: bold;
    font-size: 18px;
  }
  .el-carousel{
    width: 80%;
    height: fit-content;
  }
  .footer_page{
    user-select: none;
    height: 9rem;
    line-height: 9rem;
    width: 76%;
    left: 12%;
    bottom: 0;
    text-align: center;
    position: fixed;
    font-family: 微软雅黑, sans-serif;
    font-weight: 400;
    font-style: normal;
    font-size: 14px;
    color: rgba(149, 165, 166,.3);
  }
  .footer_page a{
    text-decoration: none;
    color: rgba(149, 165, 166,.4);
  }
  .footer_page a:hover{
    text-decoration: none;
    color: rgba(149, 165, 166,.8);
  }
</style>
